import React, { useCallback, useEffect, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import '../Dropdown.css';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Dropdown } from 'react-bootstrap';
import { H5, P } from 'components/reusable-css';
import * as Styles from 'pages/member/firewall/FireWall.style';
import { useTranslation } from 'react-i18next';
import CreateTemplatePanel from './CreateTemplatePanel';
import ClickNHold from 'react-click-n-hold';
import Tooltip from 'components/Tooltip';
import { DeleteAnimation } from 'pages/member/dns/DNS.style';
import { DELETE_FIREWALL } from '../queries';
import { mutationProps } from 'utils/custom-hook';
import { useMutation } from 'react-query';
import { useMediaQuery } from '@mui/material';
import SlidingPanels from 'components/common/sliding-panel';
import { handleConvert } from '../utils';

const CardList = ({ show, rowID, item, handleToggle, refetch }) => {
  const { t } = useTranslation();
  const [anim, setAnim] = useState();
  const match = useMediaQuery('(max-width:550px)');
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const handleSettingPanel = () => setIsOpenSetting(!isOpenSetting);
  const [isOpenCreateTemp, setIsOpenCreateTemp] = useState(false);
  const [isOpenCreateObj, setIsOpenCreateObj] = useState(false);
  const { mutate: deleteFirewall, isLoading: deleteFirewallLoading } = useMutation(DELETE_FIREWALL);
  const handleCreateTempModal = () => {
    setIsOpenCreateTemp(!isOpenCreateTemp);
  };
  const handleDelete = async (id) => {
    await deleteFirewall(
      { id },
      mutationProps(
        false,
        {
          onSuccess: async () => {
            await refetch();
          },
        },
        t,
      ),
    );
  };

  const escFunction = useCallback((event) => {
    if (event.key === 'Escape') {
      if (isOpenCreateObj) {
        setIsOpenCreateObj(false);
        return;
      }
      setIsOpenSetting(false);
      setIsOpenCreateTemp(false);
    }
  }, [isOpenSetting, isOpenCreateObj]);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  return (
    <Styles.SingleList loading={deleteFirewallLoading}>
      <Styles.CardContent>
        <Styles.FirstContent>
          <Icon name="circle" className="circle" />
          <H5>{handleConvert(item.label)}</H5>
          <Icon name="pencil" className="pencil" onClick={handleCreateTempModal} />
        </Styles.FirstContent>
        <Styles.SecondContent>
          <Styles.StatusConteiner>
            <Styles.BlueContainer>
              <P>
                {t(item?.vs_total > 1 ? 'vs/firewall.string8' : 'vs/firewall.string7', {
                  vs_total: item?.vs_total || 0,
                  vs_applied_to: item?.vs_applied_to || 0,
                })}
              </P>
            </Styles.BlueContainer>
            <Styles.GreenContainer>
              <P>
                {t('vs/firewall.string5', {
                  rules: item?.rules_total,
                })}
              </P>
            </Styles.GreenContainer>
          </Styles.StatusConteiner>
          <Styles.ActionConteiner>
            <Icon size="large" name="setting" onClick={() => setIsOpenSetting(true)} />
            <Dropdown onToggle={() => handleToggle(item?.id)} show={show && item.id == rowID}>
              <Dropdown.Toggle id="dropdown-basic">
                <MoreHorizIcon />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ borderRadius: '10px', boxShadow: 'unset', zIndex: 99999 }} className="menu">
                <Dropdown.Item
                  style={{ paddingTop: '7px', paddingBottom: '7px', margin: '5px 0' }}
                  className="icon d-flex"
                >
                  <Icon className="play circle outline" />
                  <P>{t('vs/firewall.string59')}</P>
                </Dropdown.Item>
                <Dropdown.Item
                  style={{ paddingTop: '7px', paddingBottom: '7px', margin: '5px 0' }}
                  className="icon d-flex"
                >
                  <Icon className="pause circle outline" />
                  <P>{t('vs/firewall.string60')}</P>
                </Dropdown.Item>
                <Dropdown.Item
                  style={{ paddingTop: '7px', paddingBottom: '7px', margin: '5px 0' }}
                  className="icon d-flex"
                >
                  <Icon className="cogs" />
                  <P>{t('vs/firewall.string61')}</P>
                </Dropdown.Item>
                <ClickNHold
                  time={1.5}
                  onStart={() => setAnim(true)}
                  onEnd={() => setAnim(false)}
                  onClickNHold={() => handleDelete(item?.id)}
                >
                  <Tooltip title={t('vs/firewall.string12')} placement="left">
                    <DeleteAnimation anim={anim} className="icon">
                      <Icon className="trash alternate" />
                      <P>{t('vs/firewall.string11')}</P>
                    </DeleteAnimation>
                  </Tooltip>
                </ClickNHold>
              </Dropdown.Menu>
            </Dropdown>
          </Styles.ActionConteiner>
        </Styles.SecondContent>
      </Styles.CardContent>
      {isOpenSetting && (
        <SlidingPanels size={match ? 100 : 78} isOpen={isOpenSetting} isClose={setIsOpenSetting}>
          <CreateTemplatePanel
            item_id={item?.id}
            label={handleConvert(item?.label)}
            isClose={handleSettingPanel}
            mainRefectch={refetch}
            isOpenCreateObj={isOpenCreateObj}
            setIsOpenCreateObj={setIsOpenCreateObj}
          />
        </SlidingPanels>
      )}
      {isOpenCreateTemp && (
        <SlidingPanels size={match ? 100 : 78} isOpen={isOpenCreateTemp} isClose={setIsOpenCreateTemp}>
          <CreateTemplatePanel
            item_id={item?.id}
            label={handleConvert(item?.label)}
            isClose={handleCreateTempModal}
            mainRefectch={refetch}
            isOpenCreateObj={isOpenCreateObj}
            setIsOpenCreateObj={setIsOpenCreateObj}
          />
        </SlidingPanels>
      )}
    </Styles.SingleList>
  );
};

export default React.memo(CardList);
